import { datadogRum } from '@datadog/browser-rum';

if (
  process.env.REACT_APP_DD_APPLICATION_ID &&
  process.env.REACT_APP_DD_CLIENT_TOKEN
) {
  datadogRum.init({
    applicationId: process.env.REACT_APP_DD_APPLICATION_ID,
    clientToken: process.env.REACT_APP_DD_CLIENT_TOKEN,
    site: 'datadoghq.eu',
    service: 'lyne-sortation-ui',
    env: process.env.REACT_APP_ENV,
    version: process.env.REACT_APP_BUILD_VERSION,
    sampleRate: 100,
    replaySampleRate: 0,
    trackInteractions: true,
    defaultPrivacyLevel: 'allow',
  });
}
